import { ESuburbanUtility, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectSuburbanUtilitiesFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const SuburbanUtilitiesContainer: FC = () => {
  const { label, value, options } = useSelector(selectSuburbanUtilitiesFilter);

  const onChange = useFilterChangeCallback();

  const handleSuburbanUtilitiesChange = useCallback(
    (newValue: NonEmptyArray<ESuburbanUtility> | null) => {
      onChange({ action: 'setSuburbanUtilities', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter options={options} value={value} onFilterChange={handleSuburbanUtilitiesChange} />
    </AdvancedFilterRow>
  );
};
